// extracted by mini-css-extract-plugin
export default {"suggestions":"NoResults_suggestions__pTPb3","none":"NoResults_none__LpmN5","link":"NoResults_link__7Oooh"};